import {CookieConfig} from 'types/Cookie'

import {safeDecode} from '../../../utils/url'
import {getCookie, setCookie} from '../../utils/cookies'
import userCityCookieConfig from './cookieConfig'

const getCookieOptions = (cookieConfig: CookieConfig) => {
  const {secure, sameSite, maxAge: expires, domain} = cookieConfig.options
  return {
    expires,
    secure,
    sameSite,
    domain
  }
}

/**
 * Persist the user city in a cookie
 * @param cityName - The user city to persist
 */
export const persistUserCity = (cityName: string) => {
  const userCity = cityName ? safeDecode(cityName) : ''
  setCookie(
    userCityCookieConfig.name,
    userCity,
    getCookieOptions(userCityCookieConfig)
  )
}

/**
 * Get the persisted user city from a cookie
 * @returns The persisted user city
 */
export const getPersistedUserCity = () => {
  const userCity = getCookie(userCityCookieConfig.name) ?? ''
  return safeDecode(userCity)
}
